import React from 'react'

const LineArrowRight = (props) => {
	return(
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill={props.fill}><path d="M16.787 9.47l-5.087-5.25a.712.712 0 0 0-1.028 0 .767.767 0 0 0 0 1.061l3.85 3.97h-12.795a.75.75 0 0 0 0 1.5h12.79l-3.849 3.97a.767.767 0 0 0 0 1.061.712.712 0 0 0 1.029 0l5.091-5.25a.767.767 0 0 0 0-1.061z" transform="translate(-1 -4)"/></svg>
	)
}

export default LineArrowRight